import mutations from './mutations';
const Author = {
    namespaced: true,
    state: {
        foto: 'https://raw.githubusercontent.com/arindyproject/latihan_vue3/main/src/json_test/277439829_172114501816815_7261629511784878264_n.jpg',
        name: 'Aji Ari Adam',
        company_name: 'ArindyProject',
        description: 'Diterjemahkan dari bahasa Inggris-Deskripsi adalah segala jenis komunikasi  yang bertujuan untuk memperjelas suatu tempat, objek, orang, kelompok, ',
        donasi:{
            qr : "",
            msg: "",
        },
        contacts: [
            {
                title: '@arindyproject',
                icon: ['fab', 'github'],
                url: 'https://github.com/arindyproject',
                description: 'Diterjemahkan dari bahasa Inggris-Deskripsi adalah segala jenis komunikasi '
            },
            {
                title: '@devarindy',
                icon: ['fab', 'instagram'],
                url: 'https://www.instagram.com/devarindy/',
                description: 'Diterjemahkan dari bahasa Inggris-Deskripsi adalah segala jenis komunikasi '
            },
            {
                title: 'arindyproject',
                icon: ['fab', 'youtube'],
                url: 'https://www.youtube.com/arindyproject',
                description: ''
            }
        ]
    },
    mutations
};

export default Author;
